import { useContext, useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { DATATYPE_DOCUMENT, TITLE } from "../databases/spName";
import BlockContainer from "./BlockContainer";
import { SelectForm } from "./FormItem";
import { AdminContext, initialFilter } from "../contexts/AdminContext";


const RenderFilters = () => {

    const [filter, setFilter] = useState({...initialFilter})
    const { users, setFilters, filterLoading, onSearchClick, onClearFilter } = useContext(AdminContext)

    const OptionFilter = useMemo(() => {
        let a = {"-" : "-"}
        for (const field in TITLE) {
            
            /*if (![DATATYPE_DOCUMENT].includes(TITLE[field].datatype)) {
                
            }*/
            if (TITLE[field].TH || TITLE[field].CN) {
                a = {...a, [field] : `${TITLE[field].TH} / ${TITLE[field].CN}`}
            }
        }
        return a
    }, [])

    useEffect(() => {
        return () => {
            setFilter({...initialFilter})
        }
    }, [])

    const onFilterFieldChange = (e, index) => {
        let f = {...filter}
        f[index].field = e.target.value
        if (TITLE[f[index].field] && typeof TITLE[f[index].field].init === 'boolean') {
            f[index].value = TITLE[f[index].field].init
        }
        else if (f[index].field && TITLE[f[index].field] && TITLE[f[index].field].options) {
            if (Array.isArray(TITLE[f[index].field].options)) {
                f[index].value = TITLE[f[index].field].options[0]
            }
            else if (typeof TITLE[f[index].field].options === 'object') {
                f[index].value = Object.keys(TITLE[f[index].field].options)[0]
            }
            else {
                f[index].value = ''
            }
        }
        else {
            f[index].value = ''
        }
        setFilter(f)
    }

    const onClearFilterClick = () => {
        //console.log(initialFilter)
        setFilter({    
            0 : {
                field : '-',
                value : '',
            },
            1 : {
                field : '-',
                value : '',
            },
            2 : {
                field : '-',
                value : '',
        }})
        onClearFilter()

    }

    return (
        <div>
            <div className="bold">ตัวกรอง</div>
            <BlockContainer>
                <Row bsPrefix='row align-items-center text-center'>
                    {[0, 1, 2].map((index) => (
                        <Col key={index} lg={3} sm={12} xs={12}>
                            <Row bsPrefix='row align-items-center text-center mb-2'>
                                <Col bsPrefix='col-1'>{index + 1}.</Col>
                                <Col>
                                    <SelectForm noMargin={true} value={filter[index].field} options={OptionFilter} onChange={e => onFilterFieldChange(e, index)} />
                                </Col>
                                <Col>
                                    {filter[index].field === 'round'
                                    ?   <SelectForm noMargin={true} value={filter[index].value} options={{...TITLE.round.options, '99' : 'ทั้งหมด'}} onChange={e => setFilter(f => ({...f, [index] : {...f[index], value : e.target.value}}))}/>
                                    : filter[index].field && TITLE[filter[index].field] && TITLE[filter[index].field].options
                                    ?   <SelectForm noMargin={true} value={filter[index].value} options={TITLE[filter[index].field].options} onChange={e => setFilter(f => ({...f, [index] : {...f[index], value : e.target.value}}))}/>
                                    : filter[index].field && TITLE[filter[index].field] && TITLE[filter[index].field].datatype === DATATYPE_DOCUMENT ?
                                        <SelectForm noMargin={true} value={filter[index].value} options={{[false] : 'ยังไม่อัปโหลด', [true] : 'อัปโหลดแล้ว'}} onChange={e => setFilter(f => ({...f, [index] : {...f[index], value : e.target.value}}))}/>
                                    :   <Form.Control value={filter[index].value} onChange={e => setFilter(f => ({...f, [index] : {...f[index], value : e.target.value}}))} />
                                }
                                    
                                </Col>
                            </Row>
                        </Col>
                    ))}
                    <Col lg={1} xs={6} bsPrefix='col text-end'>
                        <Button onClick={() => {setFilters(filter); onSearchClick(filter)}} disabled={filterLoading} >{<Spinner animation="border" hidden={!filterLoading} size='sm'/>}ค้นหา</Button>
                    </Col>
                    <Col lg={1} xs={6}>
                        <Button variant='danger' disabled={filterLoading} onClick={onClearFilterClick}>ล้าง</Button>
                    </Col>
                </Row>
                <br />
                <div>ผลการค้นหา : {Object.keys(users).length} คน</div>
            </BlockContainer>
            
            <br />
            
        </div>
        
    )
}

export default RenderFilters;